import apiClient from '@/services/axios'

export async function getByVenueId(venueId) {
  var response = await apiClient.get(`/EodReports/venue/${venueId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get eod reports')
}
